import { ICON__image_solid } from '@/assets/icons_fa';
import { HOOK_GRID2D_CELL__icon_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__icon_size';

interface PROPS {
  width: number;
  height: number;
  className?: string;
}

export function GRID2D_CELL__placeholder({ width, height, className }: PROPS) {
  const { icon_width, icon_height } = HOOK_GRID2D_CELL__icon_size(width, height);

  return (
    <div
      style={{ width, height }}
      className={`${className} 
                  flex-center 
                  rounded-2xl 
                  border border-component-border `}
    >
      <ICON__image_solid style={{ width: icon_width, height: icon_height }} className="!text-component-item" />
    </div>
  );
}
